import { render } from "./CommonItem.vue?vue&type=template&id=5985b6bd&scoped=true"
import script from "./CommonItem.vue?vue&type=script&lang=js"
export * from "./CommonItem.vue?vue&type=script&lang=js"

import "./CommonItem.vue?vue&type=style&index=0&id=5985b6bd&scoped=true&lang=css"

import exportComponent from "E:\\2022（新）\\映象网手机版\\image-mobile-version\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5985b6bd"]])

export default __exports__